import { useState } from 'react'

import { useSetAutoRenewalMutation } from 'src/Redux/adsCampaignApi'

interface UseAutoRenewResult {
  autoRenew: boolean
  isDisableModalOpen: boolean
  closeDisableModal: () => void
  handleAutoRenewChange: (checked: boolean) => void
  handleDisableConfirm: () => void
}

export const useAutoRenew = (
  campaignId: number | undefined,
  serverValue: boolean | undefined,
): UseAutoRenewResult => {
  const [setAutoRenewal] = useSetAutoRenewalMutation()
  const [autoRenewOverride, setAutoRenewOverride] = useState<boolean | null>(
    null,
  )
  const [isDisableModalOpen, setIsDisableModalOpen] = useState(false)

  const autoRenew = autoRenewOverride ?? serverValue ?? true

  const handleAutoRenewChange = (checked: boolean): void => {
    if (!checked) {
      setIsDisableModalOpen(true)
      return
    }
    setAutoRenewOverride(true)
    if (campaignId) {
      setAutoRenewal({ id: campaignId, shouldAutoRenew: true })
    }
  }

  const handleDisableConfirm = (): void => {
    setIsDisableModalOpen(false)
    setAutoRenewOverride(false)
    if (campaignId) {
      setAutoRenewal({ id: campaignId, shouldAutoRenew: false })
    }
  }

  return {
    closeDisableModal: () => setIsDisableModalOpen(false),
    autoRenew,
    isDisableModalOpen,
    handleAutoRenewChange,
    handleDisableConfirm,
  }
}
